import { gql } from '../../__generated__'

export const projectDeepQuery = gql(`
  query ProjectsDeepGetById(
    $projectId: String!
    $data: ManagePublicLink
    $excludeStash: Boolean = true
    $excludeHide: Boolean = false
  ) {
    data: projectsGetById(
      projectId: $projectId
      data: $data
      excludeStash: $excludeStash
      excludeHide: $excludeHide
    ) {
      ...ProjectSchemaDeep
    }
  }
`)

export const projectsGetByIdQuery = gql(`
  query ProjectsGetById($projectId: String!) {
    data: projectsGetById(projectId: $projectId) {
      ...ProjectSchema
    }
  }
`)

export const employeePreferencesByProjectId = gql(`
  query EmployeePreferencesByProjectId($projectId: String!) {
    data: projectsGetById(projectId: $projectId) {
        employeePreferences {
        ...EmployeePreferencesSchema
      }
    }
  }
`)

export const meInProjectQuery = gql(`
  query MeInProject($projectId: String!) {
    data: projectsGetById(projectId: $projectId) {
      id
      me {
        ...ParticipantSchema
      }
    }
  }
`)

export const projectForExport = gql(`
  query ProjectForExport($projectId: String!) {
    data: projectsGetById(projectId: $projectId) {
      ...ProjectForExportSchema
    }
  }
`)

export const validateProjectForRiseQuery = gql(`
  query ValidateProjectForRise($projectId: String!) {
    validateProjectForRise(projectId: $projectId) {
      blocks {
        blockType
        status
        targets {
          name
          status
        }
      }
    }
  }
`)
